
<template>
  <div class="flex justify-center items-center">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>
